export default __webpack_public_path__ + "static/media/card-digital-india-nfo-banner.cd2241a6.png";